var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-facebook';
                    var viewUrl = 'sprite.svg#view-icon-facebook';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-facebook#icon-facebook';
                            viewUrl = 'sprite.svg?icon-facebook#view-icon-facebook';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16.7 16.6',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };